"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeOffering = exports.getAuthorization = exports.prepareCloseOffering = void 0;
const internal_1 = require("../../internal");
const types_1 = require("../../types");
const conversion_1 = require("../../utils/conversion");
/**
 * @hidden
 */
function prepareCloseOffering(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { context: { polymeshApi: { tx: { sto: txSto }, }, }, context, } = this;
        const { asset: { id: assetId }, asset, id, } = args;
        const offering = new internal_1.Offering({ id, assetId }, context);
        const { status: { sale }, } = yield offering.details();
        if ([types_1.OfferingSaleStatus.Closed, types_1.OfferingSaleStatus.ClosedEarly].includes(sale)) {
            throw new internal_1.PolymeshError({
                code: types_1.ErrorCode.UnmetPrerequisite,
                message: 'The Offering is already closed',
            });
        }
        const rawAssetId = (0, conversion_1.assetToMeshAssetId)(asset, context);
        const rawId = (0, conversion_1.bigNumberToU64)(id, context);
        return {
            transaction: txSto.stop,
            args: [rawAssetId, rawId],
            resolver: undefined,
        };
    });
}
exports.prepareCloseOffering = prepareCloseOffering;
/**
 * @hidden
 */
function getAuthorization({ asset }) {
    return {
        permissions: {
            transactions: [types_1.TxTags.sto.Stop],
            assets: [asset],
            portfolios: [],
        },
    };
}
exports.getAuthorization = getAuthorization;
/**
 * @hidden
 */
const closeOffering = () => new internal_1.Procedure(prepareCloseOffering, getAuthorization);
exports.closeOffering = closeOffering;
//# sourceMappingURL=closeOffering.js.map